// extracted by mini-css-extract-plugin
export default {"projects":"projects-module--projects--2MJ6m","container":"projects-module--container--LfFiG","title":"projects-module--title--2VVSV"};